import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { CartDrawer, CartFab } from "@/components/CartDrawer";
import { LegalPage } from "@/components/LegalPages";
import { AdminPage } from "@/components/AdminPage";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/Marquee";
import { About } from "@/components/About";
import { Signature } from "@/components/Signature";
import { MenuSection } from "@/components/Menu";
import { FlyerSection } from "@/components/FlyerSection";
import { Reserve } from "@/components/Reserve";
import { Location } from "@/components/Location";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  const path = window.location.pathname;
  if (path.startsWith("/admin")) {
    return <AdminPage />;
  }
  const legal = path.match(/^\/(impressum|datenschutz|agb)/);
  if (legal) {
    return <LegalPage page={legal[1]} />;
  }

  return (
    <CartProvider>
      <div className="App bg-teal-dark">
        <Toaster position="top-center" theme="dark" richColors />
        <CartFab />
        <CartDrawer />
        <Navbar />
        <main>
          <Hero />
          <MarqueeStrip />
          <About />
          <Signature />
          <MenuSection />
          <FlyerSection />
          <Reserve />
          <Location />
        </main>
        <Footer />
      </div>
    </CartProvider>
  );
}

export default App;
